import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { useUser } from '@clerk/clerk-react';

const MessageTemplate = ({ connection, jobTitle, company }) => {
  const { user } = useUser();
  const [copied, setCopied] = useState(false);

  const generateMessage = () => {
    return `Hi ${connection.firstName},

I hope you're doing well! I came across the opening for the ${jobTitle} role at ${company}, and it aligns perfectly with my skills and experience.

I'd greatly appreciate it if you could refer me for the position or guide me on how best to proceed. Looking forward to hearing from you!

Regards,
${user?.firstName || 'User'}`;
  };

  const handleCopyMessage = () => {
    const message = generateMessage();
    navigator.clipboard.writeText(message);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
  };

  return (
    <button 
      onClick={handleCopyMessage}
      className="copy-button"
      title="Copy message template"
      style={{ 
        background: 'none',
        border: 'none',
        padding: '2px',
        cursor: 'pointer',
        color: '#121313',
        transition: 'all 0.3s ease',
        transform: copied ? 'scale(1.1)' : 'scale(1)'
      }}
    >
      {copied ? <Check size={16} color="#22c55e" /> : <Copy size={14} />}
    </button>
  );
};

export default MessageTemplate; 